import { render } from "./ProfileDetails.vue?vue&type=template&id=ca70dfa2&ts=true"
import script from "./ProfileDetails.vue?vue&type=script&lang=ts"
export * from "./ProfileDetails.vue?vue&type=script&lang=ts"

import "./ProfileDetails.vue?vue&type=style&index=0&id=ca70dfa2&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/profile/ProfileDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca70dfa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca70dfa2', __exports__)) {
    api.reload('ca70dfa2', __exports__)
  }
  
  module.hot.accept("./ProfileDetails.vue?vue&type=template&id=ca70dfa2&ts=true", () => {
    api.rerender('ca70dfa2', render)
  })

}


export default __exports__